import { render, staticRenderFns } from "./CardConfigForm.vue?vue&type=template&id=a98db46a&"
import script from "./CardConfigForm.vue?vue&type=script&lang=ts&"
export * from "./CardConfigForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports